import { gql } from "graphql-request";

const SERVER_CREATE_SURVEY_CLIMATE_FEEDBACK = gql`
  mutation SERVER_createFeedbackSurveyAreas($input: FeedbackSurveyAreaInput!) {
    createFeedbackSurveyAreas(input: $input) {
      id
    }
  }
`;
export default SERVER_CREATE_SURVEY_CLIMATE_FEEDBACK;